// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'box-lines-2-solid';

export const Component = () => (
  <path d='M2.921 0H21.6c.814 0 1.485.287 2.06.862.575.574.861 1.245.861 2.06v18.677c0 .814-.287 1.485-.861 2.06-.575.575-1.246.861-2.06.861H2.921c-.814 0-1.484-.287-2.06-.861C.288 23.084 0 22.413 0 21.599V2.921c0-.814.287-1.484.862-2.06C1.436.288 2.107 0 2.922 0ZM6.37 10.297h11.78c.335 0 .479-.144.479-.479 0-.335-.144-.479-.479-.479H6.369c-.335 0-.48.144-.48.479 0 .335.145.479.48.479Zm0 4.885h11.78c.335 0 .479-.144.479-.479 0-.335-.144-.479-.479-.479H6.369c-.335 0-.48.144-.48.48 0 .334.145.478.48.478Z' />
);

export const viewBox = '0 0 25 25';
